import { render, staticRenderFns } from "./updatePasien.vue?vue&type=template&id=8b284818&"
import script from "./updatePasien.vue?vue&type=script&lang=js&"
export * from "./updatePasien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports